module.exports = __webpack_public_path__ + "static/media/mc.6ac67761.webp";